import { SETTINGS_GENERAL } from '@/config/settings.general'

type ReachGoalParams =
    | string
    | number
    | boolean
    | null
    | Record<string, unknown>

type ReachGoal = ({
    goalName,
    params,
}: {
    type?: 'reachGoal' | 'hit' | 'params' | 'setUserID'
    goalName?: string
    params?: ReachGoalParams
}) => void

interface Props {
    userId?: string
}

export function useReachGoal({ userId }: Props = {}): ReachGoal {
    if (SETTINGS_GENERAL.IS_PRODUCTION && userId && window.ym) {
        window.ym(SETTINGS_GENERAL.YANDEX_METRIKA_ID, 'setUserID', userId)
    }
    return ({ type = 'reachGoal', goalName, params }) => {
        if (SETTINGS_GENERAL.IS_PRODUCTION && window.ym) {
            window.ym(
                SETTINGS_GENERAL.YANDEX_METRIKA_ID,
                type,
                goalName,
                params
            )
        } else {
            console.warn('Goal: ', type, goalName, params)
        }
    }
}
